__turbopack_context__.v({
  "amityBrand": "CustomHeroProgramSlider-module-scss-module__PeWavW__amityBrand",
  "card_link": "CustomHeroProgramSlider-module-scss-module__PeWavW__card_link",
  "gridContainer": "CustomHeroProgramSlider-module-scss-module__PeWavW__gridContainer",
  "gridImageWrapper": "CustomHeroProgramSlider-module-scss-module__PeWavW__gridImageWrapper",
});
